import React from 'react';
import { InfoIcon } from 'lucide-react';
export function ImportantNotice() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2146">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2147">
        <div className="rounded-xl p-6 md:p-8 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-2148">
          <div className="flex items-start gap-4" data-id="element-2149">
            <InfoIcon size={28} className="flex-shrink-0 mt-1" style={{
            color: '#c8a84b'
          }} data-id="element-2150" />
            <div data-id="element-2151">
              <h3 className="text-lg font-bold uppercase mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#c8a84b'
            }} data-id="element-2152">
                Important Notice
              </h3>
              <p className="text-base font-medium leading-relaxed" style={{
              color: '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2153">
                MEMBERS WISHING TO RENEW THEIR MEMBERSHIP ARE RESPONSIBLE FOR
                KNOWING THE DATE OF EXPIRATION OF THEIR MEMBERSHIP YEAR.
                EVERYONE IS DIFFERENT.
              </p>
              <p className="text-sm mt-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2154">
                (The Membership Manager will send email notifications about
                expiring memberships but cannot guarantee you will receive them
                and does not follow up for those who do not "Renew")
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}